import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['nonBillable', 'billable', 'hourlyRate'];

  toggleBilling() {
    const nonBillable = this.nonBillableTarget.checked;
    this.billableTargets.forEach((element) => {
      element.hidden = nonBillable;
    });
    if (nonBillable) {
      this.hourlyRateTarget.value = '0';
    }
  }
}
